export default {
    nextButton: 'Continuar',
    finished: 'Último passo',
    birthChart: 'Mapa Astral',
    welcomeButton: 'Continuar',
    congratulations: 'Parabéns!',
    birthData: 'Dados de nascimento',
    graphicMap: 'CLIQUE PARA AMPLIAR',
    finishButton: 'Completar cadastro',
    welcome: 'Olá, <strong>{userName}</strong>!<p>Seja bem-vindo(a) ao Astrolink!</p>',
    homeLink: 'area-pessoal?onb=1',

    cityStep: {
        title: 'PRECISAMOS SABER',
        placeholder: 'Pesquisar Cidade',
        message: 'Em qual cidade você nasceu?',
        deskMessage: 'Em qual cidade <br /> você nasceu?',
        errorMessage: 'Ops! Não encontramos sua cidade. Confira se digitou corretamente e tente de novo!',
        tip: `As informações aqui coletadas são indispensáveis para a elaboração do mapa astral.
        As mesmas ficarão armazenadas no perfil do titular para manutenção do seu mapa astral, 
        poderão ser corrigidas 1 vez e excluídas de forma definitiva caso seja a vontade do titular`,
        cityNotFound: 'Não encontrou sua cidade na lista? ',
        createMap: 'Criando seu mapa',
        clickHere: 'Clique aqui'
    },

    gender: {
        male: 'Masculino',
        female: 'Feminino',
        title: 'Vamos Começar',
        noBinary: 'Não binário',
        message: 'Qual é o seu gênero?',
        deskMessage: 'Qual é o seu gênero?',
    },

    referenceGender: {
        he: 'Ele',
        she: 'Ela',
        select: 'Selecionar',
        title: 'Certo, agora...',
        message: 'Como gostaria de ser referênciado(a)?',
        messageOld: 'Como gostaria de ser <br /> referênciado(a)?',
    },
    
    lastStep: {
        titleAllRight: 'TUDO CERTO! MUITO OBRIGADO',
        titleCompleted: 'SEU CADASTRO ESTÁ COMPLETO!',
        again: 'Tentar Novamente',
        sendAgainLink: 'novo envio',
        sendAgainLinkMarketing: 'Enviar e-mail novamente',
        button: 'Ativar meu Cadastro',
        mapButton: 'Ver meu Mapa!',
        invalidCode: 'Código inválido',
        message: 'Calculando seu Mapa Astral',
        insertCode: 'Agora é só confirmar sua conta',
        deskMessage: 'Calculando seu <br /> Mapa Astral',
        error: 'Ops, ocorreu um erro ao calcular seu mapa',
        insertCodeOld: 'Agora é só confirmar <br /> sua conta',
        newCode: 'Um e-mail foi enviado com um novo código de confirmação.',
        setCodeBelow: 'Digite abaixo o código de 4 dígitos que enviamos para o seguinte e-mail:',
        warning: 'O email pode chegar com atraso, mas não se preocupe pois já estamos resolvendo!',
        manyAttempts: 'Você fez muitas tentativas de login! Por segurança, enviamos um novo código de verificação por e-mail.',
        loading: 'Estamos verificando os posicionamentos astrológicos de acordo com o horário e local de nascimento para gerar o seu <br />Mapa Astral completo.',
        sendAgain: `O e-mail pode demorar um pouco para chegar ou 
                    ser listado como <strong>spam</strong>. Caso não 
                    tenha recebido, solicite um `,
        sendAgainMarketing: 'O e-mail pode demorar alguns minutos para chegar.<br/>Verifique também sua caixa de SPAM.<br/>Não recebeu? ',
        signUpCompleted: 'Cadastro completo!',
        confirmSniperLink: 'Confirme sua conta clicando no link que enviamos para o seguinte e-mail:',
        openGmail: 'Abrir meu e-mail',
        refreshPageAfterConfirm: 'Ao confirmar o e-mail você deve ser redirecionado automaticamente. Se isso não acontecer, ',
        touchHere: 'toque aqui',
        clickHere: 'clique aqui',
        toRedirect: ' para redirecionar.',
        openGmailNow: 'Abrir meu e-mail agora',
    },

    birthDateStep: {
        title: 'ESTAMOS QUASE LÁ!',
        message: 'Qual sua data de nascimento?',
        deskMessage: 'Qual sua data de <br /> nascimento?',
        alreadyClose: 'Falta pouco!',
        error: {
            birthday_not_valid: 'Data inválida',
            birthday_too_short: 'É preciso ser maior de 13 anos para usar o Astrolink',
            birthday_too_long: 'É preciso ter menos de 120 anos para usar o Astrolink',
        },
    },
    
    birthTimeStep: {
        title: 'O HORÁRIO É ESSENCIAL',
        button: 'Informar depois',
        informAfter: 'Não sei meu horário de nascimento / informar depois',
        message: 'Que horas você <br /> nasceu?',
        deskMessage: 'Que horas você nasceu?',
        warning: 'Precisamos deste dado com exatidão para calcular o seu ascendente',
        lastThing: 'Última coisa',
        tip: `O horário do seu nascimento é o que permite o cálculo do seu ascendente e tudo o que é relativo a ele. 
              É uma informação muito importante para que possamos criar o seu mapa astral completo! 
              Você pode conseguir essa informação em sua certidão de nascimento.`,
    },

    knowledge: {
        title: 'UMA ÚLTIMA PERGUNTA',
        confirm: 'Confirmar',
        beginner: 'Iniciante, não sei quase nada.',
        message: 'O quanto você conhece de astrologia?',
        expert: 'Muito, sei sobre aspectos, dignidades, etc.',
        intermediate: 'Pouco, sei sobre signos e ascendentes.',
        advanced: 'Médio, conheço bem signos, planetas e casas.',
    },

    birthTimeMessageStep: {
        referenceMale: 'tranquilo',
        refereceFemale: 'tranquila',
        message: 'Aproveite sua jornada e fique {reference}, pois iremos te lembrar de atualizar seu horário de nascimento.',
    },

    welcomeMessage: `<p>Seu <span>Mapa Astral</span> 
                     é um guia que revela informações 
                     importantes sobre a sua vida de acordo 
                     com a astrologia. Compreender o próprio 
                     mapa é fundamental para o seu <strong>autoconhecimento.</strong></p>`,

    subscribeMessage: `<p>Sua assinatura foi concluída com sucesso 
                       e agora você já pode usar a <strong>Sinastria</strong> 
                       e outros recursos incríveis. <br/> Mas antes, 
                       precisamos fazer o seu <strong>Mapa Astral</strong>!</p>`,
    
    datePicker: {
        year: 'Ano',
        month: 'Mês',
        cancel: 'Cancelar',
        select: 'Selecionar',
        title: 'Selecione o ano, mês e o dia <br /> que você nasceu',
        months: {
            January: 'Janeiro',
            February: 'Fevereiro',
            March: 'Março',
            April: 'Abril',
            May: 'Maio',
            June: 'Junho',
            July: 'Julho',
            August: 'Agosto',
            September: 'Setembro',
            October: 'Outubro',
            November: 'Novembro',
            December: 'Dezembro'
        }
    },

    nestle: {
        aries: 'Jovem, espontâne{article} e de personalidade forte, igual à crocância inconfundível do <b>Chokito</b>!',
        touro: 'Agradável, romântic{article} e sonhador{article}, assim como a combinação irresistível de chocolate e morango do <b>Sensação</b>!',
        gemeos: 'Sagaz, antenad{article} e espontâne{article}. Todo mundo te adora, assim como adoram o <b>Crunch</b>!',
        cancer: 'Sensível, nostálgic{article} e levíssim{article}, assim como o gostinho caseiro do <b>Galak</b>!',
        leao: 'Autêntic{article}, sofisticad{article} e icônic{article}, assim como a receita suíça inconfundível do <b>Alpino</b>!',
        virgem: 'Exalando inspiração, conforto e acolhimento, você faz a alegria de qualquer dia, assim como o cremosíssimo Nestlé <b>Classic</b>!',
        libra: '{articleUpper} queridinh{article} da galera, sensível e amad{article} como o fofíssimo e nostálgico <b>Lollo</b>!',
        escorpiao: 'Sensual, apegad{article} e indulgente, você é a cara do puxa e repuxa do nosso querido <b>Smash</b>!',
        sagitario: 'Autêntico, descontraído e chei{article} de histórias pra contar, assim como o fresquíssimo <b>Prestígio</b>!',
        capricornio: 'Sincer{article}, motivad{article} e sempre pront{article} para o dia, assim como o poderoso <b>Charge</b>!',
        aquario: 'Irrevente, antenad{article} e pront{article} para dividir. Você tem tudo a ver com a hype do <b>KitKat</b>!',
        peixes: 'Otimista, distraíd{article} chei{article} de sonhos, assim como o <b>Suflair</b>, levíssimo que derrete na boca!',
    }
};